import React from 'react';
import ReactSVG from 'react-svg';

import iconFile from 'appSrc/v5/assets/images/desired.svg';

const DesiredIcon = ( props ) => {
    const className = `icon-wrapper set-color ${ props.className || '' }`.trim();

    return (
        <ReactSVG src={ iconFile }
        wrapper='div'
        { ...props }
        className={ className } />
    );
};
DesiredIcon.defaultProps = {
    className: '',
};

export default DesiredIcon;
